export type LogProps = ({ message?: string } & Record<string, any>) | any;

export type Log = {
  (message: string, props?: LogProps): void;
  (props: LogProps): void;
};

export type BaseLogger = {
  error: Log;
  warn: Log;
  info: Log;
  debug: Log;
  trace: Log;
};

export const logLevels = ["trace", "debug", "info", "warn", "error"] as const;
export type LogLevel = (typeof logLevels)[number];
